exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageSpinner-module__loading-overlay___2b06v{position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#0827e9;background-color:hsla(0,0%,100%,.8)}", ""]);

// exports
exports.locals = {
	"loading-overlay": "PageSpinner-module__loading-overlay___2b06v"
};